module.exports = __webpack_public_path__ + "img/gongzuozhenshipaizhao_yidong.cd8fa262.png";